export enum EntityActionScopeType {
    global = 'Global',
    entity = 'Entity',
}

export class ActionsListFilters {
    public entityId?: string = undefined;
    public actionTypes?: string[] = undefined;
    public search?: string = undefined;
    public createdFrom?: string = undefined;
    public createdTo?: string = undefined;
    public resolvedFrom?: string = undefined;
    public resolvedTo?: string = undefined;
    public resolvedBy?: string = undefined;
    public outcome?: 'accepted' | 'rejected' = undefined;
    public scope?: 'entity' | 'global' = undefined;
}
